var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"212043f72ec6f279deaf6fbd4636dc8482c28af2"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from "@sentry/nextjs";
import { isLocal } from "@utils/utils";

if (!isLocal()) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

    // Filter turnstile errors
    beforeSend(event, hint) {
      const exception = hint && hint.originalException;
      if (
        event.exception?.values?.[0]?.type === "TurnstileError" ||
        (exception instanceof Error && exception.name === "TurnstileError")
      ) {
        return null; // If it's a TurnstileError, don't send the event to Sentry.
      }

      // event related to login and turnstile
      if (event.exception?.values?.[0]?.value?.includes("Java exception was raised during method invocation")) {
        return null;
      }

      // event related to login and turnstile
      if (event.exception?.values?.[0]?.value?.includes("Java object is gone")) {
        return null;
      }

      // event related to members area when changing to another class, it needs a deep dive to understand
      if (event.exception?.values?.[0]?.value?.includes("Event `CustomEvent` (type=error) captured as exception")) {
        return null;
      }

      if (event.exception?.values?.[0]?.value?.includes("Invariant: attempted to hard navigate to the same URL")) {
        return null;
      }

      if (event.level === "warning" || event.message?.includes("CustomEvent")) {
        return null;
      }

      return event; // Otherwise, send the event.
    },

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.01,

    sampleRate: 0.01,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    replaysOnErrorSampleRate: 0.01,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.01,

    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: [
      new Sentry.Replay({
        // Additional Replay configuration goes in here, for example:
        maskAllText: false,
        blockAllMedia: true,
        maxReplayDuration: 1000 * 6, // 6 seconds
      }),
    ],
    ignoreErrors: [
      "[Cloudflare Turnstile] Error: 300030",
      "[Cloudflare Turnstile] Error: 600010",
      "[Cloudflare Turnstile] Error: 400060",
      "Can't find variable: _AutofillCallbackHandler",
      "fb_xd_fragment",
      "Unexpected token '<'",
      "Cannot read properties of null (reading 'querySelector')",
      "SecurityError: Failed to read the 'sessionStorage' property from 'Window': Access is denied for this document",
      "Java exception was raised during method invocation",
      "undefined is not an object",
      "No error message",
    ],
  });
}
